import {CookieManagement} from './cookie-management.component';
import {CookieManagementCookies} from './model/cookies.model';
import {CookiesEnum} from "./model/cookies.enum";
import {CookieManagementTemplate} from "./cookie-management-template";

export class CookieManagementDomInjector {
    private activeStep: HTMLElement = null;

    private readonly introStep: HTMLElement;
    private readonly selectStep: HTMLElement;
    private readonly template: CookieManagementTemplate;

    constructor(
        private document: Document,
        private hostElement: HTMLElement,
        private cookieManagement: CookieManagement
    ) {
        this.template = new CookieManagementTemplate(this.document, this.cookieManagement);
        this.hostElement.replaceWith(this.template.container);
        this.hostElement = this.template.container;

        this.introStep = this.hostElement.querySelector('.cookie-management-modal-step-introduction') as HTMLElement;
        this.selectStep = this.hostElement.querySelector('.cookie-management-modal-step-selection') as HTMLElement;
        this.injectControlsHandlers();
    }

    private injectControlsHandlers(): void {
        const editButton = this.introStep.querySelector('.cookie-management-edit');
        editButton.addEventListener('click', () => {
            this.selectEditStep();
        });

        const previousButton = this.selectStep.querySelector('.cookie-management-previous');
        previousButton.addEventListener('click',() => {
            this.selectIntroStep();
        });

        const acceptAllButton = this.introStep.querySelector('.cookie-management-accept');
        acceptAllButton.addEventListener('click', () => {
           this.cookieManagement.acceptAll();
           this.close();
        });

        const denyButton = this.introStep.querySelector('.cookie-management-deny');
        denyButton.addEventListener('click', () => {
            this.cookieManagement.denyAll();
            this.close();
        });

        const editForm: HTMLFormElement = this.selectStep.querySelector('form.cookie-management-settings-form');
        editForm.addEventListener('submit', (event) => {
            const formData = new FormData(editForm);
            const cookiesBooleanMap = new Map<CookiesEnum, boolean>();
            cookiesBooleanMap.set(CookiesEnum.analytics, formData.get(CookiesEnum.analytics) === 'on');
            cookiesBooleanMap.set(CookiesEnum.marketing, formData.get(CookiesEnum.marketing) === 'on');
            this.cookieManagement.acceptMap(cookiesBooleanMap);
            this.close();
            event.preventDefault();
            return false;
        });
    }

    private closeActiveStep(): void {
        if (this.activeStep) {
            this.activeStep.style.display = 'none';
        }

        this.activeStep = null;
    }

    private displayWrapper(): void {
        this.hostElement.style.display = 'block';
        this.document.body.style.overflow = 'hidden'
    }

    private closeWrapper(): void {
        this.hostElement.style.display = 'none';
        this.document.body.style.overflow = 'scroll';
    }

    registerControls(cookies: CookieManagementCookies): void {
        cookies.cookiesSubjectMap.get(CookiesEnum.analytics).subscribe((value: boolean) => {
            const inputElement = this.selectStep.querySelector('.cookie-management-input-analytics') as HTMLInputElement;
            inputElement.checked = value;
        });

        cookies.cookiesSubjectMap.get(CookiesEnum.marketing).subscribe((value: boolean) => {
            const inputElement = this.selectStep.querySelector('.cookie-management-input-marketing') as HTMLInputElement;
            inputElement.checked = value;
        });
    }

    selectIntroStep(): void {
        this.closeActiveStep();
        this.introStep.style.display = 'block';
        this.activeStep = this.introStep;
    }

    selectEditStep(): void {
        this.closeActiveStep();
        this.selectStep.style.display = 'block';
        this.activeStep = this.selectStep;
    }

    close(): void {
        this.closeWrapper();
        this.closeActiveStep();
    }

    openIntroWindow(): void {
        this.displayWrapper();
        this.closeActiveStep();
        this.selectIntroStep();
    }

    openEditWindow(): void {
        this.displayWrapper();
        this.closeActiveStep();
        this.selectEditStep();
    }
}
